export default function DataTable({

  columns = [],
  data = [],
  emptyMessage =
    "No data found"

}) {

  return (

    <div
      className="
      bg-white
      rounded-3xl
      shadow-sm
      border
      border-gray-100
      overflow-hidden
    "
    >

      {/* =====================================
          TABLE WRAPPER
      ===================================== */}

      <div
        className="
        overflow-x-auto
      "
      >

        <table
          className="
          w-full
          min-w-[900px]
        "
        >

          {/* =====================================
              HEADER
          ===================================== */}

          <thead
            className="
            bg-gray-50
            border-b
          "
          >

            <tr>

              {
                columns.map(
                  (col) => (

                    <th
                      key={col.key}
                      className="
                      px-6
                      py-4
                      text-left
                      text-xs
                      font-bold
                      uppercase
                      tracking-wider
                      text-gray-500
                      whitespace-nowrap
                    "
                    >
                      {col.title}
                    </th>
                  )
                )
              }

            </tr>

          </thead>

          {/* =====================================
              BODY
          ===================================== */}

          <tbody>

            {
              data.length === 0

              ? (

                <tr>

                  <td
                    colSpan={
                      columns.length
                    }
                    className="
                    text-center
                    py-16
                    text-gray-400
                    text-lg
                  "
                  >
                    {emptyMessage}
                  </td>

                </tr>

              )

              : (

                data.map(
                  (row, index) => (

                    <tr
                      key={
                        row.id || index
                      }
                      className="
                      border-b
                      last:border-0
                      hover:bg-gray-50
                      transition
                      duration-150
                    "
                    >

                      {
                        columns.map(
                          (col) => (

                            <td
                              key={col.key}
                              className="
                              px-6
                              py-5
                              text-sm
                              text-gray-700
                              whitespace-nowrap
                            "
                            >

                              {
                                col.render

                                ? col.render(row)

                                : row[col.key]
                              }

                            </td>
                          )
                        )
                      }

                    </tr>
                  )
                )
              )
            }

          </tbody>

        </table>

      </div>

    </div>
  );
}